var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('account-info-bar-base',{attrs:{"display-application-id":"","display-application-status":""}})}
var staticRenderFns = []

export { render, staticRenderFns }